// TOUR-15 — Ads Guidance walkthrough (curate categories / templates / policies for reps).

import type { FireflyTourArtifact } from "../tourTypes";

export const ADS_GUIDANCE_TOUR_ID = "tour-ads-guidance";

export const ADS_GUIDANCE_TOUR: FireflyTourArtifact = {
  id: ADS_GUIDANCE_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "ads guidance tour",
    "curate social posts for reps",
    "how do i curate ads for reps",
    "give me a tour of ads guidance",
    "walk me through ads guidance",
    "show me ads guidance",
    "ads library for trainers",
    "curate ads patterns tour",
  ],
  bucketRelevance: ["manager"],
  requiredRoles: ["trainer", "marketing", "ads_guidance_editor", "admin", "owner"],
  steps: [
    {
      id: "nav-ads-guidance",
      target: {
        mode: "adsGuidance",
        anchorId: "mode-nav-adsGuidance",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "adsGuidance",
      copy: {
        title: "Open Ads Guidance",
        body: "Curate categories, templates, and policies that Ads Assistant reads when reps log posts. Tap Ads Guidance in the Manager bucket (sidebar or bottom bar).",
      },
      waitForClick: true,
    },
    {
      id: "guidance-surface",
      target: { mode: "adsGuidance", anchorId: "ads-guidance-surface", scrollIntoView: true },
      copy: {
        title: "Ads Guidance hub",
        body: "This Manager surface authors the library — not the daily log path. Reps consume categories and coaching from Sales → Ads Assistant.",
      },
      advanceOn: "next_button",
    },
    {
      id: "library-grid",
      target: { mode: "adsGuidance", anchorId: "ads-guidance-library", scrollIntoView: true },
      copy: {
        title: "Library sections",
        body: "Open Categories or Templates to define chips and named formats reps pick when logging. Post tags add trainer vocabulary for the index.",
      },
      advanceOn: "next_button",
    },
    {
      id: "policies-section",
      target: {
        mode: "adsGuidance",
        anchorId: "ads-guidance-publish-or-policies",
        scrollIntoView: true,
      },
      copy: {
        title: "Policies",
        body: "Tap Policies to expand guideline text and substring detection patterns the stub analyzer surfaces next to logged posts.",
      },
      waitForClick: true,
    },
    {
      id: "policies-save",
      target: {
        mode: "adsGuidance",
        anchorId: "ads-guidance-publish-or-policies",
        scrollIntoView: true,
      },
      copy: {
        title: "Add or update policies",
        body: "Add policy saves guideline text and detection patterns for this org. You perform saves yourself — the tour will not create or delete policies.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "adsGuidance", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Reps log posts from Ads Assistant — not here. Ask Firefly anytime for the Ads Assistant tour or other Manager mode walkthroughs.",
      },
      advanceOn: "next_button",
    },
  ],
};
